const api = require('contentful');const config = {
  space: '941hu2xw64ln',
  accessToken: process.env.VUE_APP_CONTENTFUL_API_KEY,
  environment: process.env.VUE_APP_BRANCH_KEY
}

export const contentful =  api.createClient(config)
